module.exports = __webpack_public_path__ + "img/vertical_4_4_3.819ce46e.png";